import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import {
  category1234SubCategories,
  category6789SubCategories,
  category3890SubCategories,
  category2342SubCategories,
  category2343SubCategories,
} from '../fixtures/SubCategory';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get('/api/resource/categories/1234/subcategories', (req, res, ctx) => {
    return res(ctx.json(category1234SubCategories));
  }),

  rest.get('/api/resource/categories/6789/subcategories', (req, res, ctx) => {
    return res(ctx.json(category6789SubCategories));
  }),

  rest.get('/api/resource/categories/3890/subcategories', (req, res, ctx) => {
    return res(ctx.json(category3890SubCategories));
  }),

  rest.get('/api/resource/categories/2342/subcategories', (req, res, ctx) => {
    return res(ctx.json(category2342SubCategories));
  }),

  rest.get('/api/resource/categories/2343/subcategories', (req, res, ctx) => {
    return res(ctx.json(category2343SubCategories));
  }),
];

export default handlers;
